import { useState } from 'react'
import { Interval, OfferEntry } from '../../../../../types/Controlling/OfferEntry'
import { PlusIcon } from '@heroicons/react/24/outline'
import Modal from '../../../../UI/Modal/Modal'
import { useSelector } from 'react-redux'
import props from '../../../../../redux/props'
import EntryMask from './EntryMask'
import { getUUID } from '../../../../../utility'

type Props = {
  add: (entry: OfferEntry) => void
}
const Add: React.FC<Props> = ({ add }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const [show, setShow] = useState(false)
  const [data, setData] = useState<OfferEntry>({ uuid: getUUID(), interval: Interval.ONCE })

  const toggle = () => setShow(!show)

  const confirm = () => {
    add(data)
    setData({ uuid: getUUID(), interval: Interval.ONCE })
    setShow(false)
  }

  const set = (key: keyof OfferEntry) => (value: any) => setData({ ...data, [key]: value })

  return (
    <>
      <div>
        <div
          onClick={toggle}
          className="ml-auto bg-blue border border-blue hover:bg-white group transition-all cursor-pointer py-1 flex justify-center aspect-square w-7"
        >
          <PlusIcon className="stroke-white group-hover:stroke-blue w-5" />
        </div>
      </div>
      <Modal noForm show={show} onConfirm={confirm} onClose={toggle} title={t.controlling.offer.entry.add.title}>
        <EntryMask data={data} set={set} />
      </Modal>
    </>
  )
}

export default Add
